import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Buttons, CancelButton, ModalCard, FormMessage, Checkbox } from '~/components';
import { useRating } from '~/contexts';

const P = styled.p`
  margin-bottom: 2rem;
`;

const ReviewButtons = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;
`;

function ReviewModal({ ratingId, onClose }) {
  const [reviewed, setReviewed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const { submitReview } = useRating();

  const handleSubmit = async () => {
    if (!reviewed) {
      onClose();
      return;
    }

    setIsSubmitting(true);
    const { success, message } = await submitReview(ratingId);

    if (success) {
      onClose();
    } else {
      setError(message || 'An error has occurred.');
    }

    setIsSubmitting(false);
  };

  const handleClose = () => {
    onClose();
  };

  if (!ratingId) return null;

  return (
    <ModalCard title="Review Ruddr" onClose={handleClose}>
      <ModalCard.Body>
        <P>
          We love to get feedback from our users! Receive $50 by providing a review of Ruddr on G2 and Capterra via the
          buttons below.
        </P>

        <ReviewButtons>
          <Button
            onClick={() =>
              window.open(
                'https://www.g2.com/contributor/ruddr-led-50-incentive-021f2204-dac8-4962-ae85-797295def5de?secure%5Bpage_id%5D=ruddr-led-50-incentive-021f2204-dac8-4962-ae85-797295def5de&secure%5Brewards%5D=true&secure%5Btoken%5D=0280c9f670c00c4986e9dc71b28c0dba818eca9132a35b133f127454a1833ae4',
                '_blank',
              )
            }>
            Review Ruddr on G2
          </Button>
          <Button
            onClick={() =>
              window.open(
                'https://reviews.capterra.com/products/new/424a38ce-9b2a-4668-86c0-4a172e5bc678/a06b4879-641d-491e-885a-f0f43a4893ac?lang=en',
                '_blank',
              )
            }>
            Review Ruddr on Capterra
          </Button>
        </ReviewButtons>

        <Checkbox
          checked={reviewed}
          onChange={(e) => setReviewed(e.target.checked)}
          label="I have already reviewed Ruddr on G2 and Capterra."
        />

        {error && <FormMessage.Error>{error}</FormMessage.Error>}
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton data-testid="submit_review" onClick={handleSubmit} isLoading={isSubmitting}>
            Close
          </CancelButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default ReviewModal;
